import { DateUtils } from '@smooved/core';

export class MoveDateUtils {
    /**
     * Calculates days relative to move date from current date
     * @param movingDate The move date as a Date object or ISO string
     * @param currentDate Current date (defaults to today)
     * @returns Number of days from current date to move date
     *          - Negative number means move date is in the future (e.g., -1 = tomorrow)
     *          - 0 means move date is today
     *          - Positive number means move date is in the past (e.g., +1 = yesterday)
     */
    public static getDaysToMoveDate(movingDate: Date | string, currentDate: Date = DateUtils.today()): number {
        const movingDateObj = DateUtils.toDate(movingDate);
        if (!movingDateObj) return null;

        // DateUtils.getDaysIntervalBetweenTwoDates returns positive for future dates and negative for past dates
        // We need to invert this to match our expected behavior (negative for future, positive for past)
        const interval = DateUtils.getDaysIntervalBetweenTwoDates(movingDateObj, currentDate);

        if (interval === null) return null;
        if (interval === 0) return 0;

        return -interval;
    }

    /**
     * Formats a move date for PostHog tracking
     * @param movingDate The move date as a Date object or ISO string
     * @returns Date string in YYYY-MM-DD format or null if invalid
     */
    public static formatMovingDateForTracking(movingDate: Date | string): string {
        const dateObj = DateUtils.toDate(movingDate);
        if (!dateObj) return null;

        // Format as YYYY-MM-DD for consistent tracking
        return DateUtils.format(dateObj, 'YYYY-MM-DD');
    }
}
